import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [];


  showModal(event){
    event.preventDefault();
    const element = event.target.matches('button') ? event.target : this.getParentsUntil(event.target, 'button')[0];
    const modalId = element.dataset.modalTarget;
    console.warn('modalId', modalId);
    $(`#${modalId}`).modal('show');
  }

  closeFacilityFormSubmissionSendFeedbackModal(event) {
    event.preventDefault();
    $('#facility-form-submission-send-feedback-modal').modal('hide');
  }

  openFacilityFormSubmissionSendFeedbackModal() {
    $('#facility-form-submission-send-feedback-modal').modal('show');
  }

  openViewFeedbackModal(e) {
    const element = $('#facility-form-submission-view-feedback-modal');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.attr('src', element.data('targetUrl'));
    element.modal('show');
  }

  closeViewFeedbackModal() {
    const element = $('#facility-form-submission-view-feedback-modal');
    element.modal('hide');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.src = '';
  }

  getParentsUntil(el, selector) {
    let parents = [],
      _el = el.parentNode;
    while (_el && typeof _el.matches === 'function') {
      parents.unshift(_el);
      if (_el.matches(selector)) return parents;
      else _el = _el.parentNode;
    }
    return [];
  };
}